import React from 'react';
import { StepParentInfo } from './steps/StepParentInfo';
import { StepMinorChildren } from './steps/StepMinorChildren';
import { StepGuardian } from './steps/StepGuardian';
import { StepScopeAuthority } from './steps/StepScopeAuthority';
import { StepDuration } from './steps/StepDuration';
import { StepReview } from './steps/StepReview';

export const IMMIGRATION_POA_STEPS = [
  'Parent / Grantor Info',
  'Minor Children',
  'Primary Guardian',
  'Alternate Guardian',
  'Scope of Authority',
  'Duration & Conditions',
  'Review & Submit',
];

export const validateStep = (stepIndex, formData) => {
  const errors = {};

  if (stepIndex === 0) {
    if (!formData.parentFullName?.trim()) errors.parentFullName = 'Full legal name is required';
    if (!formData.parentDOB) errors.parentDOB = 'Date of birth is required';
    if (!formData.parentCountry?.trim()) errors.parentCountry = 'Country of origin is required';
    if (!formData.parentImmigrationStatus) errors.parentImmigrationStatus = 'Immigration status is required';
    if (!formData.parentAddress?.trim()) errors.parentAddress = 'Current address is required';
  }

  if (stepIndex === 1) {
    const children = formData.children || [];
    if (children.length === 0) errors.children = 'At least one child is required';
    children.forEach((c, i) => {
      if (!c.name?.trim()) errors[`child_${i}_name`] = `Child ${i + 1} name is required`;
      if (!c.dob) errors[`child_${i}_dob`] = `Child ${i + 1} DOB is required`;
      if (!c.relationship?.trim()) errors[`child_${i}_relationship`] = `Child ${i + 1} relationship is required`;
    });
  }

  if (stepIndex === 2) {
    if (!formData.guardian1FullName?.trim()) errors.guardian1FullName = 'Guardian full name is required';
    if (!formData.guardian1Relationship?.trim()) errors.guardian1Relationship = 'Relationship is required';
    if (!formData.guardian1Address?.trim()) errors.guardian1Address = 'Address is required';
    if (!formData.guardian1Phone?.trim()) errors.guardian1Phone = 'Phone number is required';
    if (!formData.guardian1Accepts) errors.guardian1Accepts = 'Guardian must accept responsibility';
  }

  if (stepIndex === 3) {
    if (!formData.guardian2FullName?.trim()) errors.guardian2FullName = 'Alternate guardian full name is required';
    if (!formData.guardian2Relationship?.trim()) errors.guardian2Relationship = 'Relationship is required';
    if (!formData.guardian2Address?.trim()) errors.guardian2Address = 'Address is required';
    if (!formData.guardian2Phone?.trim()) errors.guardian2Phone = 'Phone number is required';
    if (!formData.guardian2Accepts) errors.guardian2Accepts = 'Alternate guardian must accept responsibility';
  }

  if (stepIndex === 4) {
    const scopes = formData.scopeOfAuthority || [];
    if (scopes.length === 0) errors.scopeOfAuthority = 'Select at least one scope of authority';
  }

  if (stepIndex === 5) {
    if (!formData.effectiveDate) errors.effectiveDate = 'Effective date is required';
    if (!formData.expirationOption) errors.expirationOption = 'Select an expiration option';
    if (formData.expirationOption === 'date' && !formData.expirationDate) {
      errors.expirationDate = 'Expiration date is required';
    }
    if (!formData.triggeringCondition) errors.triggeringCondition = 'Triggering condition is required';
  }

  return errors;
};

export const ImmigrationPOAWizard = ({ formData, onChange, currentStep, errors }) => {
  const props = { formData, onChange, errors };

  const stepComponents = [
    <StepParentInfo {...props} />,
    <StepMinorChildren {...props} />,
    <StepGuardian {...props} guardianKey="guardian1" label="Primary Guardian" />,
    <StepGuardian {...props} guardianKey="guardian2" label="Alternate Guardian" />,
    <StepScopeAuthority {...props} />,
    <StepDuration {...props} />,
    <StepReview formData={formData} />,
  ];

  return <div>{stepComponents[currentStep]}</div>;
};